// Datatables functionality for filtering archive
(function ($) {
  let tables = {};

  $(function () {
    /**
     * Wait until DataTable is available before executing callback.
     */
    function waitForDataTable(callback) {
      if (typeof DataTable !== 'undefined') {
        callback();
      } else {
        setTimeout(() => waitForDataTable(callback), 50);
      }
    }

    /**
     * Show/hide the "Load More" button depending on rows left.
     */
    function updateLoadMoreVisibility(blockId) {
      const table = tables[blockId];
      const totalRows = table.rows({ filter: 'applied' }).count();
      const visibleRows = table.page.len();
      const $loadMoreWrapper = $(`#${blockId} .load-more-wrapper`);
      if (totalRows > visibleRows && visibleRows !== -1) {
        $loadMoreWrapper.removeClass('hidden');
      } else {
        $loadMoreWrapper.addClass('hidden');
      }
    }

    /**
     * Apply a filter to the DataTable.
     */
    function applyFilter($archive, filterSlug) {
      const blockId = $archive.attr('id');
      tables[blockId]
        .columns(1)
        .search(filterSlug || '', true, false)
        .draw();
      tables[blockId].page.len($archive.data('limit-posts')).draw(); // Reset to initial page length
      // Update URL if needed
      const url = new URL(window.location.href);
      if (filterSlug) {
        url.searchParams.set('filter', filterSlug);
      } else {
        url.searchParams.delete('filter');
      }
      window.history.replaceState(null, '', url);
      updateLoadMoreVisibility(blockId);
    }

    /**
     * Initialize one posts archive block.
     */
    function initArchive($archive) {
      const pageLength = $archive.data('limit-posts');
      const blockId = $archive.attr('id');
      const tableSelector = `#posts-${blockId}`;
      const urlParams = new URLSearchParams(window.location.search);
      const filterFromUrl = urlParams.get('filter');

      const table = new DataTable(tableSelector, {
        ordering: false,
        pageLength: pageLength,
        stateSave: false,
        layout: {
          topStart: null,
          topEnd: null,
          bottomStart: null,
          bottomEnd: null,
        },
      });

      tables[blockId] = table;

      const $filterButtons = $archive.find('.filter-button');
      let $defaultBtn;

      if (filterFromUrl) {
        $defaultBtn = $filterButtons.filter(`[data-filter="${filterFromUrl}"]`).first();
      } else {
        $defaultBtn = $filterButtons.first();
      }

      if ($defaultBtn.length) {
        $filterButtons.removeClass('is-active');
        $defaultBtn.addClass('is-active');
        applyFilter($archive, $defaultBtn.data('filter'));
      } else {
        updateLoadMoreVisibility(blockId);
      }
    }

    /**
     * Handle filter button click inside archive.
     */
    function handleFilterClick(e) {
      e.preventDefault();

      const $btn = $(this);
      const $archive = $btn.closest('.posts-archive');
      const $filterButtons = $archive.find('.filter-button');
      // Remove active from all and set only this one
      $filterButtons.removeClass('is-active');
      $btn.addClass('is-active');
      applyFilter($archive, $btn.data('filter'), $btn.data('filter'));
    }

    /**
     * Handle "Load All" button click.
     */
    function handleLoadAllClick() {
      const $btn = $(this);
      const ariaControls = $btn.attr('aria-controls');
      const $table = $('#' + ariaControls);
      const $archive = $table.closest('.posts-archive');
      const table = $table.DataTable();
      table.page.len(-1).draw();
      updateLoadMoreVisibility($archive.attr('id'));
    }

    // Wait until DataTable is ready
    waitForDataTable(() => {
      $('.posts-archive').each(function () {
        initArchive($(this));
      });
      // Event bindings
      $(document).on('click', '.posts-archive .filter-button', handleFilterClick);
      $(document).on('click', '.load-more-btn', handleLoadAllClick);
    });
  });
})(jQuery);
